import { Layout } from "@/components/layout/Layout";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { page404 } from "@/const/page404";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";
import { createQueryCityCategoryPage } from "@/strapiQuery/cityCategoryPage";
import {
  formatFirstCityCategoryPage,
  StrapiCityCategoryPage,
} from "@/utils/formatCityCategoryPage";

type Ctx = LoadI18nMessagesProps & { params: { slug: string[] } };

export const getStaticProps = async (ctx: Ctx) => {
  const parts = ctx.params.slug; // ex: ["paris-75001","minibus-confort"]
  if (parts.length < 2) {
    return page404;
  }

  const [slugCity, slugCategory] = parts;

  const layout = await getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );
  const intlMessages = loadIntlMessages(ctx);

  const strapiCategoryPages = await getStrapiCollection<StrapiCityCategoryPage>(
    "city-vehicle-pages",
    createQueryCityCategoryPage(slugCity, slugCategory)
  );
  if (strapiCategoryPages.length === 0) {
    return page404;
  }

  const cityCategoryPageContent =
    formatFirstCityCategoryPage(strapiCategoryPages);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      slugCity: slugCity,
      slugCategory: slugCategory,
      vehicleType: cityCategoryPageContent.categoryType,
      ...cityCategoryPageContent,
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => ({
  paths: [],
  fallback: "blocking",
});

export { CityCategoryPage as default } from "@/components/pages/vehicle/cityCategoryPage/CityCategoryPage";
